import React, {useMemo} from "react";
import QRCodeGen from "qrcode-generator";

// Simple SVG QR renderer that scales to container
// Props:
// - value: string to encode
// - ecLevel: 'L'|'M'|'Q'|'H'
// - margin: quiet zone modules
// - className: optional css class
const QRCode = ({value = "", ecLevel = "M", margin = 2, className = ""}) => {
  const svgMarkup = useMemo(() => {
    if (!value) return "";
    try {
      const qr = QRCodeGen(0, ecLevel); // 0 -> automatic type number
      qr.addData(String(value));
      qr.make();
      const moduleCount = qr.getModuleCount();
      const size = moduleCount + margin * 2;
      // Build path with tiny cells by using viewBox with module grid and 100% size
      let rects = "";
      for (let r = 0; r < moduleCount; r++) {
        for (let c = 0; c < moduleCount; c++) {
          if (qr.isDark(r, c)) {
            const x = c + margin;
            const y = r + margin;
            rects += `<rect x="${x}" y="${y}" width="1" height="1"/>`;
          }
        }
      }
      const svg = `<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges" preserveAspectRatio="none">\n  <rect width="100%" height="100%" fill="#fff"/>\n  <g fill="#000">${rects}</g>\n</svg>`;
      return svg;
    } catch (e) {
      console.error("QR generation failed", e);
      return "";
    }
  }, [value, ecLevel, margin]);

  return (
    <div className={`qr-svg ${className}`} dangerouslySetInnerHTML={{__html: svgMarkup}} />
  );
};

export default QRCode;
